import React from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import Cards from '../../../base/cards/Cards';

const KPIDetailCard = ({ title, totalValue, prefix = '', suffix = '', decimals = 0, details }) => {
  return (
    <Cards>
      <div className="d-flex flex-column p-1">
        <div className="d-flex flex-column justify-content-center align-items-start text-start">
          <div
            className="title-card-dash-main"
            style={{ fontSize: '30px', fontWeight: 700, lineHeight: 1, color: '#222' }}
          >
            <CountUp
              start={0}
              end={totalValue}
              duration={1}
              separator=","
              decimals={decimals}
              decimal="."
              prefix={prefix}
              suffix={suffix}
            />
          </div>
          <div style={{ fontSize: '16px', color: '#000', opacity: 0.6, marginTop: '8px' }}>
            {title}
          </div>
        </div>

        {/* Small Table inside */}
        {details && details.length > 0 && (
          <div
            className="d-flex flex-column mt-4"
            style={{ border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}
          >
            {details.map((item, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center px-4 py-3"
                style={{
                  borderBottom: index !== details.length - 1 ? '1px solid #E5E7EB' : 'none',
                  backgroundColor: '#ffffff'
                }}
              >
                <span
                  title={item.label}
                  style={{
                    fontSize: '15px',
                    color: '#4B5563',
                    fontWeight: 400,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '8px',
                    flex: '1 1 auto'
                  }}
                >
                  {item.label}
                </span>
                <span
                  style={{
                    fontSize: '16px',
                    color: '#111827',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                  }}
                >
                  {prefix}
                  {typeof item.value === 'number'
                    ? item.value.toLocaleString('en-US', {
                        minimumFractionDigits: decimals,
                        maximumFractionDigits: decimals
                      })
                    : item.value}
                  {suffix}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </Cards>
  );
};

KPIDetailCard.propTypes = {
  title: PropTypes.string.isRequired,
  totalValue: PropTypes.number.isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  decimals: PropTypes.number,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  )
};

export default KPIDetailCard;
